import { useStore } from '@nanostores/vue';
import { atom } from 'nanostores';
import { computed } from 'vue';

export class ScrollStore {
  lockList = new Set();

  $isLocked = atom(false);

  get isLocked() {
    const data = useStore(this.$isLocked);
    return computed(() => data.value);
  }

  lock(id) {
    this.lockList.add(id);
    this.updateState();
  }

  unlock(id) {
    this.lockList.delete(id);
    this.updateState();
  }

  forceUnlock() {
    this.lockList.clear();
    this.updateState();
  }

  updateState() {
    this.$isLocked.set(this.lockList.size !== 0);
  }
}
